import { useState, useEffect } from "react";
import { useGetDeviceQuotaChangeLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import logger from "../../utils/logger";

/**
 * Cihaz KOTA DEĞİŞİM logları (2026-08-25).
 *
 * Kota hareketleri eskiden "Bilgi Değişikliği" ve "Manual Kota Yükleme"
 * arasında dağılmıştı; otomatik dağıtım ise cihaz raporunda hiç görünmüyordu.
 * Bu hook, diğer cihaz rapor hook'larıyla birebir aynı sözleşmeyi döner
 * (ReportTab getActiveReport() ile seçiyor).
 */
export const useDeviceQuotaChangeReportData = (deviceId, token) => {
  const [input, setInput] = useState({
    type: "QuotaChange",
  });
  const [date, setDate] = useState(null);
  const [dateSecond, setDateSecond] = useState(null);
  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [info, setInfo] = useState(null);

  const [getDeviceQuotaChangeLogsforReport, { data, isLoading, error }] =
    useGetDeviceQuotaChangeLogsforReportMutation();

  const handleGetLogData = async () => {
    if (!deviceId || !token || !date || !dateSecond) {
      return;
    }

    try {
      setDatas([]);

      const result = await getDeviceQuotaChangeLogsforReport({
        id: deviceId,
        createdInfo: date,
        createdInfoSecond: dateSecond,
        token: token,
      }).unwrap();

      if (result && result.data) {
        setDatas(result.data);
      }
    } catch (err) {
      logger.error("❌ Quota Change Report Error:", err);
    }
  };

  useEffect(() => {
    if (data && data.data) {
      setDatas(data.data);
    }
  }, [data]);

  return {
    input,
    setInput,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    Datas,
    selectedDate,
    setSelectedDate,
    info,
    setInfo,
    isLoading,
    error,
    handleGetLogData,
  };
};
